// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-scheduler-wrapper {
    min-height: 100vh;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    padding: 2rem;
  }
  
  .calendar-scheduler-container {
    max-width: 1200px;
    margin: 0 auto;
    background: white;
    border-radius: 20px;
    border: 3px solid #3498db;
    padding: 2rem;
  }
  
  .scheduler-header {
    text-align: center;
    margin-bottom: 3rem;
    color: #2c3e50;
  }
  
  .scheduler-header h1 {
    font-size: 2.5rem;
    margin: 1rem 0;
    background: linear-gradient(135deg, #2c3e50 0%, #3498db 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  
  .scheduler-header p {
    color: #7f8c8d;
    font-size: 1.1rem;
  }
  
  .scheduler-content {
    display: grid;
    grid-template-columns: 1fr 1.5fr;
    gap: 2rem;
  }
  
  .calendar-section {
    background: #f8f9fa;
    padding: 2rem;
    border-radius: 15px;
    border: 2px solid #e0e0e0;
  }
  
  .custom-calendar {
    width: 100% !important;
    border: none !important;
    background: white !important;
    padding: 1rem !important;
    border-radius: 10px !important;
  }
  
  .section-title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1.5rem;
    color: #2c3e50;
  }
  
  .section-title svg {
    color: #3498db;
  }
  
  .time-slots-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 0.8rem;
  }
  
  .time-slot {
    padding: 0.8rem;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    background: white;
    color: #2c3e50;
    transition: all 0.3s ease;
    cursor: pointer;
  }
  
  .time-slot:hover {
    border-color: #3498db;
    transform: translateY(-2px);
  }
  
  .time-slot.selected {
    background: #3498db;
    color: white;
    border-color: #3498db;
  }
  
  .meeting-form {
    background: white;
    padding: 2rem;
    border-radius: 15px;
    border: 2px solid #e0e0e0;
  }
  
  .form-group {
    margin-bottom: 1.5rem;
  }
  
  .form-group label {
    display: block;
    margin-bottom: 0.5rem;
    color: #2c3e50;
    font-weight: 500;
  }
  
  .form-group input,
  .form-group textarea {
    width: 100%;
    padding: 0.8rem;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    transition: all 0.3s ease;
  }
  
  .form-group input:focus,
  .form-group textarea:focus {
    border-color: #3498db;
    outline: none;
  }
  
  .schedule-button {
    width: 100%;
    padding: 1rem;
    background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 1.1rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .schedule-button:hover {
    transform: translateY(-2px);
  }
  
  .schedule-button:disabled {
    background: #e0e0e0;
    cursor: not-allowed;
  }
  
  .meetings-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 1.5rem;
    margin-top: 2rem;
  }
  
  .meeting-card {
    background: white;
    padding: 1.5rem;
    border-radius: 12px;
    border: 2px solid #e0e0e0;
    transition: transform 0.3s ease;
  }
  
  .meeting-card:hover {
    transform: translateY(-5px);
    border-color: #3498db;
  }
  
  .meeting-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
  }
  
  .meeting-time {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #3498db;
  }
  
  @media (max-width: 768px) {
    .scheduler-content {
      grid-template-columns: 1fr;
    }
    
    .calendar-scheduler-container {
      padding: 1rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/CalendarSchedular.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,6DAA6D;IAC7D,6BAA6B;IAC7B,oCAAoC;EACtC;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,gCAAgC;IAChC,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,4DAA4D;IAC5D,WAAW;EACb;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,cAAc;IACd,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;;IAEE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;IACb,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,4DAA4D;IAC5D,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;IAC3B,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE;MACE,0BAA0B;IAC5B;;IAEA;MACE,aAAa;IACf;EACF","sourcesContent":[".calendar-scheduler-wrapper {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n    padding: 2rem;\n  }\n  \n  .calendar-scheduler-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    background: white;\n    border-radius: 20px;\n    border: 3px solid #3498db;\n    padding: 2rem;\n  }\n  \n  .scheduler-header {\n    text-align: center;\n    margin-bottom: 3rem;\n    color: #2c3e50;\n  }\n  \n  .scheduler-header h1 {\n    font-size: 2.5rem;\n    margin: 1rem 0;\n    background: linear-gradient(135deg, #2c3e50 0%, #3498db 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n  }\n  \n  .scheduler-header p {\n    color: #7f8c8d;\n    font-size: 1.1rem;\n  }\n  \n  .scheduler-content {\n    display: grid;\n    grid-template-columns: 1fr 1.5fr;\n    gap: 2rem;\n  }\n  \n  .calendar-section {\n    background: #f8f9fa;\n    padding: 2rem;\n    border-radius: 15px;\n    border: 2px solid #e0e0e0;\n  }\n  \n  .custom-calendar {\n    width: 100% !important;\n    border: none !important;\n    background: white !important;\n    padding: 1rem !important;\n    border-radius: 10px !important;\n  }\n  \n  .section-title {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 1.5rem;\n    color: #2c3e50;\n  }\n  \n  .section-title svg {\n    color: #3498db;\n  }\n  \n  .time-slots-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n    gap: 0.8rem;\n  }\n  \n  .time-slot {\n    padding: 0.8rem;\n    border: 2px solid #e0e0e0;\n    border-radius: 8px;\n    background: white;\n    color: #2c3e50;\n    transition: all 0.3s ease;\n    cursor: pointer;\n  }\n  \n  .time-slot:hover {\n    border-color: #3498db;\n    transform: translateY(-2px);\n  }\n  \n  .time-slot.selected {\n    background: #3498db;\n    color: white;\n    border-color: #3498db;\n  }\n  \n  .meeting-form {\n    background: white;\n    padding: 2rem;\n    border-radius: 15px;\n    border: 2px solid #e0e0e0;\n  }\n  \n  .form-group {\n    margin-bottom: 1.5rem;\n  }\n  \n  .form-group label {\n    display: block;\n    margin-bottom: 0.5rem;\n    color: #2c3e50;\n    font-weight: 500;\n  }\n  \n  .form-group input,\n  .form-group textarea {\n    width: 100%;\n    padding: 0.8rem;\n    border: 2px solid #e0e0e0;\n    border-radius: 8px;\n    transition: all 0.3s ease;\n  }\n  \n  .form-group input:focus,\n  .form-group textarea:focus {\n    border-color: #3498db;\n    outline: none;\n  }\n  \n  .schedule-button {\n    width: 100%;\n    padding: 1rem;\n    background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 1.1rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n  }\n  \n  .schedule-button:hover {\n    transform: translateY(-2px);\n  }\n  \n  .schedule-button:disabled {\n    background: #e0e0e0;\n    cursor: not-allowed;\n  }\n  \n  .meetings-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 1.5rem;\n    margin-top: 2rem;\n  }\n  \n  .meeting-card {\n    background: white;\n    padding: 1.5rem;\n    border-radius: 12px;\n    border: 2px solid #e0e0e0;\n    transition: transform 0.3s ease;\n  }\n  \n  .meeting-card:hover {\n    transform: translateY(-5px);\n    border-color: #3498db;\n  }\n  \n  .meeting-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1rem;\n  }\n  \n  .meeting-time {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    color: #3498db;\n  }\n  \n  @media (max-width: 768px) {\n    .scheduler-content {\n      grid-template-columns: 1fr;\n    }\n    \n    .calendar-scheduler-container {\n      padding: 1rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
